"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundRoomScript = void 0;
class BoundRoomScript {
    constructor(key, args) {
        this.key = key;
        this.args = args;
    }
}
exports.BoundRoomScript = BoundRoomScript;
